<template>
  <v-card>
    <v-card-text>
      <b-section-loader v-if="$loading.isLoading('protocolSingle')" />
      <div v-else>
        <div class="d-flex justify-space-between align-center mb-3">
          <div class="font-weight-bold font-size-24">Протоколи</div>
          <v-btn-group
            color="surface"
            density="compact"
            divided
            rounded="xs"
            variant="flat">
            <v-btn
              v-if="false"
              class="mr-3"
              color="primary"
              rounded="lg"
              @click="createProtocolTask">
              Створити доручення
              <v-icon class="ml-2" color="white">mdi-plus</v-icon>
            </v-btn>
            <b-action-menu
              :actions="[
                {
                  icon: 'mdi-delete-forever',
                  title: 'Видалити протокол',
                  action: deleteProtocol,
                  disabled: false,
                  listItemProps: {
                    class: 'text-error',
                  },
                  iconProps: {
                    color: 'error',
                  },
                },
              ]">
            </b-action-menu>
          </v-btn-group>
        </div>
        <div class="d-flex align-center justify-space-between">
          <v-tabs
            color="primary"
            hide-slider
            style="border-bottom: 1px solid #e0e4e7">
            <v-tab
              :to="{
                name: 'protocol-general-info',
                params: { id: $route.params.id },
              }"
              replace>
              Основне
            </v-tab>
            <v-tab
              v-if="can('acknowledgments.viewAny')"
              :to="{
                name: 'protocol-access',
                params: { id: $route.params.id },
              }"
              replace>
              Доступність
            </v-tab>
            <v-tab
              :to="{
                name: 'protocol-connections',
                params: { id: $route.params.id },
              }"
              replace>
              Зв'язки
            </v-tab>
            <v-tab
              v-if="false"
              :to="{
                name: 'protocol-history',
                params: { id: $route.params.id },
              }"
              replace>
              Історія
            </v-tab>
            <v-tab
              v-if="false"
              :to="{ name: 'protocol-tasks', params: { id: $route.params.id } }"
              replace>
              Доручення
            </v-tab>
            <v-tab
              :to="{
                name: 'protocol-acknowledgment',
                params: { id: $route.params.id },
              }"
              replace>
              Ознайомлення
            </v-tab>
          </v-tabs>
          <div class="d-flex align-center gap-3">
            <v-menu v-if="!protocol.isActive" open-on-hover>
              <template #activator="{ props }">
                <v-btn
                  color="grey"
                  density="compact"
                  icon
                  v-bind="props"
                  variant="plain">
                  <v-icon>mdi-information-variant</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-text>
                  <div class="mb-2 d-flex align-center gap-2">
                    Актуальний протокол:
                    <span
                      v-if="protocol.actualProtocol"
                      class="link"
                      style="
                        display: inline-block;
                        max-width: 300px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      ">
                      {{ protocol.actualProtocol.name }}
                    </span>
                    <span v-else> --- </span>
                  </div>
                  <div>Причина відмови: {{ protocol.deactivateComment }}</div>
                </v-card-text>
              </v-card>
            </v-menu>
            <div
              class="d-flex align-center gap-2 protocol__btn"
              @click="activityHandler">
              <v-progress-circular
                v-if="$loading.isLoading('activateProtocol')"
                :size="18"
                :width="2"
                indeterminate></v-progress-circular>
              <span
                v-else
                :class="protocol.isActive ? 'green' : 'red'"
                class="mr-1 protocol__rounded"></span>
              <span
                :class="
                  protocol.isActive
                    ? 'protocol__active'
                    : 'protocol__deactivate'
                ">
                {{ protocol.isActive ? 'Активний' : 'Неактивний' }}
              </span>
            </div>
          </div>
        </div>
        <Skeleton v-if="$loading.isLoading('protocolSingle')" />
        <router-view v-else></router-view>
        <div
          v-show="$route.name !== 'protocol-access'"
          class="d-flex justify-end">
          <SubmitButtons
            :disabled="!protocol.$hasChanges || !can('protocols.update')"
            :loading="
              $loading.isLoading('protocolUpdate') ||
              $loading.isLoading('protocolSingle')
            "
            cancelLabel="Відмінити"
            class="mt-3"
            compact
            submitLabel="Оновити"
            @cancel="protocolReset"
            @submit="protocolUpdate" />
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Skeleton from '@/components/Skeleton.vue'
import SubmitButtons from '@/components/SubmitButtons.vue'
import { useProtocol } from './protocol'
import { navigateToItem } from '@/utils/helpers'
import { axios } from '@/plugins'
import { urlActivateProtocol, urlProtocolDelete } from '@/utils/urls'
import router from '@/router'
import { ref } from 'vue'
import { openDialog } from '@/dialog/index.ts'
import { confirm, handleAsync } from 'best-modules/plugins'
import { BActionMenu, BSectionLoader } from 'best-modules/components'
import { ENTITY_TYPE } from '@/utils/constants'
import { useCan } from '@/composables/useCan'

export default {
  components: {
    BActionMenu,
    Skeleton,
    SubmitButtons,
    BSectionLoader,
  },
  setup() {
    const { can } = useCan()
    const { protocol, protocolUpdate, protocolReset } = useProtocol()

    const deleteProtocol = () => {
      can('protocols.delete', () => {
        confirm({
          text: 'Ви впевненні що хочете видалити протокол на завжди?',
        }).then(() => {
          return axios.delete(urlProtocolDelete(protocol.id)).then(() => {
            return router.push({ name: 'protocol-list' })
          })
        })
      })
    }

    const protocolActiveLoading = ref(false)

    const activityHandler = () => {
      if (protocol.isActive) {
        return openDeactivateProtocolDialog()
      } else {
        return activateProtocol()
      }
    }

    const activateProtocol = () => {
      can('protocols.activate', () => {
        return handleAsync('activateProtocol', () => {
          return axios.patch(urlActivateProtocol(protocol.id)).then(res => {
            protocol.$set(res.data)
          })
        })
      })
    }

    const createProtocolTask = () => {
      can('task.create', () => {
        openDialog({
          name: 'CreateTask',
          dialogData: {
            taskData: {
              typeId: 3,
              entityTypeId: ENTITY_TYPE.PROTOCOL,
              entityId: protocol.id,
              name: protocol?.name,
            },
          },
          params: {},
        })
      })
    }

    const openDeactivateProtocolDialog = () => {
      can('protocols.deactivate', () => {
        openDialog({
          name: 'ProtocolDeactivate',
          dialogData: {
            protocolId: protocol.id,
          },
          params: {
            cb(updatedProtocol) {
              protocol.$set(updatedProtocol)
            },
          },
        })
      })
    }

    return {
      navigateToItem,
      deleteProtocol,
      protocolActiveLoading,
      activityHandler,
      protocol,
      protocolUpdate,
      protocolReset,
      createProtocolTask,
      can,
    }
  },
}
</script>

<style lang="scss" scoped>
.protocol {
  &__btn {
    background: transparent;
    transition: 0.3s;
    padding: 4px 12px;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
      background: #e1e1e1;
    }
  }

  &__active {
    color: #35ab8f;
    font-size: 14px;
    font-weight: 600;
  }

  &__deactivate {
    color: #ff8473;
    font-size: 14px;
    font-weight: 600;
  }

  &__rounded {
    width: 8px;
    height: 8px;
    display: block;
    border-radius: 50%;

    &.green {
      background: #35ab8f;
    }

    &.red {
      background: #ff8473;
    }
  }
}
</style>
